import {AppState, RequestStatus} from '../reducerType';
import {Asset, AssetsList} from '../../../services/assets/assetsTypes';

export const selectCurrentAsset = (state: AppState): Asset | null => state.assets.currentAsset;
export const selectCancelStatus = (state: AppState): RequestStatus | null => state.assets.cancelStatus;
export const selectAssetsList = (state: AppState): AssetsList | null => state.assets.assetsList;
export const selectRenewStatus = (state: AppState): RequestStatus => state.assets.renewStatus;